/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

export namespace Redirect {
  export interface Props {
    to: string;
  }
}

export const Redirect: React.FC<Redirect.Props> = ({ to }): null => {
  window.location.assign(to);
  return null;
};
